import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Overlay } from 'react-bootstrap';
import PaymentCategoryPopover from './PaymentCategoryPopover';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class PaymentCategorySelector extends Component {
	constructor(props) {
		super(props);
		this.handleToggle = this.handleToggle.bind(this);
		this.state = { show: false };
	}

	handleToggle() {
		this.setState({ show: !this.state.show });
	}

	renderButtonTitle() {
		const { categories, selectedCategories, t } = this.props;
		return !selectedCategories || selectedCategories.length === 0 ? t('SalesDashboard_Filter_PaymentCategory_All') :
			selectedCategories.map(id => categories.find(x => x.id === id).displayName).join(', ');
	}

	render() {
		const { buttonClassName, categories, selectedCategories, disabled, onChange, t } = this.props;

		return <div className='btn-group' style={{ position: 'relative' }}>
			<Button
				ref={button => {
					this.target = button;
				}}
				onClick={this.handleToggle}
				className={buttonClassName}
			>
				{this.renderButtonTitle()} <FontAwesomeIcon icon={faChevronDown} />
			</Button>

			<Overlay
				show={this.state.show}
				onHide={() => this.setState({ show: false })}
				placement='bottom'
				rootClose
				target={() => ReactDOM.findDOMNode(this.target)}
			>
				<PaymentCategoryPopover t={t} categories={categories} selectedCategories={selectedCategories} onChange={onChange} disabled={disabled} />
			</Overlay>

		</div>;
	}
}

export default withTranslation()(PaymentCategorySelector);